module.exports = __webpack_public_path__ + "img/share-guide.41199f5b.png";